import React, { useState } from 'react'
import { PersistentNotification } from '@reapitform/common-ui'
import { SectionTile } from '@reapitform/dashboard-ui'
import { useAgentPaymentMethods } from '../../../../api/agent-settings'
import PaymentMethodsEditForm from './edit-form'
import PaymentMethodsDisplayViewLoading from './display-view/loader'
import PaymentMethodsDisplayView from './display-view'

const PaymentMethodsSection: React.FC = () => {
  const [isEdited, setIsEdited] = useState(false)
  const { data, loading, queryKey, errorString, isRefetching } = useAgentPaymentMethods()

  const handleActionClick = () => {
    if (loading) return

    setIsEdited(true)
  }

  const handleActionClose = () => setIsEdited(false)

  const shouldShowLoading: boolean = isRefetching || loading

  return (
    <SectionTile
      title="Payment Methods"
      actionTitle={isEdited ? '' : 'Edit'}
      onActionClick={handleActionClick}
      disableMarginBottom
    >
      {shouldShowLoading && <PaymentMethodsDisplayViewLoading />}
      {!shouldShowLoading && isEdited && data && (
        <PaymentMethodsEditForm
          onClose={handleActionClose}
          onSuccess={handleActionClose}
          queryKey={queryKey}
          defaultData={data}
        />
      )}
      {!shouldShowLoading && !isEdited && <PaymentMethodsDisplayView data={data} />}
      {errorString && (
        <PersistentNotification isFullWidth isExpanded isInline intent="danger">
          Failed to load payment methods information, try refreshing your page.
        </PersistentNotification>
      )}
    </SectionTile>
  )
}

export default PaymentMethodsSection
